export default __webpack_public_path__ + "static/media/spring.06648761.svg";